import { jsx as _jsx } from "react/jsx-runtime";
import { ProductDetailTabTypes } from '@as-react/common-types';
import { Box, Link, Rating, useBreakpoints } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
import { useFeatureToggle } from '../../../hooks/useFeatureToggle';
import { useProductDetailReviewCount } from '../../../hooks/useProductDetailReviewCount';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetProductReview } from '../../../redux/product/selectors/ProductSelector';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const ReviewRating = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const reviewAverage = useSelector(makeGetProductReview());
    const { totalReviewCount, expertReviewCount } = useProductDetailReviewCount();
    const show_sticky_bar_pdp = useFeatureToggle('show_sticky_bar_pdp');
    const dispatch = useDispatch();
    const { showTabsAsAccordion } = useProductDetailContext();
    const { isMd, isLg, isXl, is2xl } = useBreakpoints();
    const isDesktop = isLg || isXl || is2xl;
    const isTablet = isMd;
    const onReviewRatingClick = () => {
        const reviewTabEl = document.getElementById(`product_detail_tab_${ProductDetailTabTypes.REVIEWS}`);
        if (!reviewTabEl) {
            return;
        }
        if (showTabsAsAccordion) {
            const scrollingOffset = ScrollUtil.getScrollingOffset(isDesktop, isTablet, show_sticky_bar_pdp);
            reviewTabEl.parentElement &&
                ScrollUtil.scrollToPosition(reviewTabEl.parentElement.offsetTop - scrollingOffset, 0, true);
        }
        else {
            ScrollUtil.scrollToElement(reviewTabEl, false, 'center');
        }
        dispatch(productActions.createSetSelectedProductTab(`product_detail_tab_${ProductDetailTabTypes.REVIEWS}`));
    };
    const handleClick = () => {
        if (totalReviewCount || expertReviewCount) {
            onReviewRatingClick();
        }
    };
    const amountTranslation = t('product.review.amount.of.reviews', { count: totalReviewCount });
    const averageScore = reviewAverage === null || reviewAverage === void 0 ? void 0 : reviewAverage.avgScore;
    return averageScore ? (_jsx(Rating, { testId: "product_rating", rating: averageScore, readOnly: true, link: {
            onClick: handleClick,
            text: amountTranslation,
        } })) : expertReviewCount > 0 ? (_jsx(Box, { children: _jsx(Link, { onClick: handleClick, size: "sm", children: amountTranslation }) })) : null;
};
